// ====================================================================
// ziven-custom-tags — CustomTagsLabel
// ====================================================================
//
// v0.1.0m: 帖子列表页 + 详情页 hero 用, 替代 vendor tagsLabel helper.
//
// 设计:
//   - 跟 vendor tagLabel + tagsLabel 1:1 视觉 (背景色, 圆角, 文字, 链接)
//   - 加 bgImageUrl 支持: 有图片走 <span class="ziven-custom-tags-label-wrap"> + background-image,
//     没图片走 vendor tagIcon() (FA 图标)
//   - 15x15 (辉哥 9/9 09:45 指定) + 圆角 + background-size: cover
//   - link: true 时用 <a href> 字符串 selector (DiscussionHero, 不用 Link class)
//   - link: false 时用 <span> (DiscussionListItem)
//
// v0.1.0m.i 改 (辉哥 9/9 09:45 反馈 "换 div 层 + background-image 思路"):
//   - 之前用 <img> 元素, vertical-align: middle 反复试 px-based top 微调 (0/1.5/2/3/1)
//     不稳定, img 中线 = line-box 中线, 跟 .TagLabel 文字 cap-height/x-height center
//     偏差 0.65-2.15px, 1px 偏差在 retina 仍可见
//   - 改用 <span class="ziven-custom-tags-label-wrap"> 15x15 + background-image: url(),
//     让 .TagLabel-text 改 display: inline-flex + align-items: center 严格 flex 居中
//   - flex 居中不受 line-height / vertical-align / line-box 中线计算影响, 严格 0 偏差
//   - 15x15 比 14px 文字高度略大, 视觉跟 vendor TagIcon 16x16 一致
//
// v0.1.0n 改 (辉哥 9/9 12:01 反馈 "再加一个上传tag图标的功能"):
//   - 后台加新字段 tag_icon_url (跟 v0.1.0 bg_image_url, v0.1.0l header_bg_image_url 区分)
//   - 用途: 帖子列表 tag 列表项 + 详情页 hero tag 显示的小图标 (15x15)
//   - 跟前 2 个字段区分:
//     - bg_image_url: 大尺寸 1200x760 背景图, /tags 卡片 60% 黑遮罩 (v0.1.0)
//     - header_bg_image_url: 1600x300 banner, 帖子列表 tag hero header (v0.1.0l)
//     - tag_icon_url: 方形小图标 256x256+, 帖子列表 15x15 显示 (v0.1.0n 本次新增)
//   - v0.1.0n.a (辉哥 9/9 12:14 反馈 "帖子列表还是用帖子背景图, 而不是新加的tag图片图标"):
//     - 去掉 v0.1.0n 原本的 bgImageUrl fallback 逻辑 (我以为保留 fallback 兼容 9/9 配的科普知识 tag,
//       辉哥反馈新加的 tag_icon_url 才是唯一字段, 不要用 bg_image_url 当帖子列表 icon)
//     - 现在逻辑: 配 tagIconUrl → 15x15 图; 没配 → 走 vendor FA icon (兜底)
//     - 副作用: 9/9 配的科普知识 tag (有 bg_image_url 没 tag_icon_url) → 突然显示雪花 FA 图标,
//       失去 9/9 配的雪景图 (雪景图数据保留在 bg_image_url 字段, 仍用作 /tags 卡片背景图, 没删)
//   - 教训: 任何 ziven 扩展加新字段时, 默认走"替换"行为 (新字段唯一, 不 fallback 老字段),
//     不假设用户想要"新旧共存 + 优先级", 除非用户明确说要 fallback
//
// 跟 vendor tagLabel 的差异:
//   - vendor tagLabel 用 mithril m() 拼单个 tag 的 vnode, 返回 m(link ? Link : 'span', attrs, children)
//   - 我们 useLink=true 时用字符串 'a' 替代 Link class
//   - 我们加 bgImageUrl 判断, 决定 children 里的 icon 部分是 <span> (background) 还是 tagIcon(<i>)
//
// 技术:
//   - 这是 mithril component class, view() 返回 vnode tree
//   - 由 extend(DiscussionListItem.prototype, 'infoItems') 触发, 通过 m(CustomTagsLabel, {tags}) 挂载
//   - ziven-core mobile jQuery 重组 onupdate 阶段会 clone 我们的 DOM 到 itemFooter, 自动生效
// ====================================================================

import app from 'flarum/common/app';
import classList from 'flarum/common/utils/classList';
import textContrastClass from 'flarum/common/helpers/textContrastClass';
import tagIcon from 'ext:flarum/tags/common/helpers/tagIcon';
import Link from 'flarum/common/components/Link';
export default class CustomTagsLabel {
  view(vnode) {
    const _vnode$attrs = vnode.attrs,
      tags = _vnode$attrs.tags,
      _vnode$attrs$link = _vnode$attrs.link,
      useLink = _vnode$attrs$link === void 0 ? false : _vnode$attrs$link;
    if (!tags || !tags.length) {
      return m("span", {
        className: "TagsLabel"
      });
    }

    // v0.1.0m.j (修): import 修对后, Wrapper 恢复 v0.1.0m.i 的 Link class (useLink=true)
    // Link class 提供 m.route.Link 行为 (内部路由 SPA 跳转), 1:1 跟 vendor tagLabel 风格
    // v0.1.0n: icon 优先级: tagIconUrl (v0.1.0n 新加字段) > bgImageUrl (v0.1.0m fallback) > vendor FA icon
    return m("span", {
      className: "TagsLabel"
    }, tags.map(tag => {
      if (!tag) return null;

      // v0.1.0n.a: 去掉 bgImageUrl fallback, 只用 tagIconUrl (辉哥 9/9 12:14 反馈)
      // 9/9 配的科普知识 tag 现在会显示 FA 雪花, 不再显示 9/9 配的雪景图
      const tagIconUrl = tag.attribute && tag.attribute('tagIconUrl');
      const color = tag.color && tag.color();
      const className = classList('TagLabel', color && 'colored', color && textContrastClass(color), tag.isChild && tag.isChild() && 'TagLabel--child');
      const style = color ? {
        '--tag-bg': color
      } : undefined;
      const iconPart = tagIconUrl ? m("span", {
        className: "ziven-custom-tags-label-wrap",
        style: {
          backgroundImage: "url(".concat(tagIconUrl, ")")
        },
        role: "img",
        "aria-label": tag.name()
      }) : tag.icon && tag.icon() ? tagIcon(tag, {
        className: 'TagLabel-icon'
      }, {
        useColor: false
      }) : null;
      return m(Link, Object.assign({
        className: className,
        style: style
      }, useLink ? {
        title: tag.description ? tag.description() : '',
        href: app.route('tag', {
          tags: tag.slug()
        })
      } : {}), m("span", {
        className: "TagLabel-text"
      }, iconPart, m("span", {
        className: "TagLabel-name"
      }, tag.name())));
    }));
  }
}
flarum.reg.add('ziiven-custom-tags', 'forum/components/CustomTagsLabel', CustomTagsLabel);